import {
  MaterialLearningGroupType,
  MaterialType,
} from "@/models/material.model";
import { GenericsUtils } from "./generics.util";

export class MaterialsUtils {
  constructor() {}
  getMaterialTypePT(lessonPlanName: string): string {
    let result = "";
    if (lessonPlanName === MaterialType.ESSENTIAL) {
      result = GenericsUtils.translateI18n("objects.essential");
    } else if (lessonPlanName === MaterialType.COMPLEMENTARY) {
      result = GenericsUtils.translateI18n("objects.complementary");
    }
    return result;
  }
  getLearningGroupTypePT(learningGroup: string): string {
    let result = "";
    if (learningGroup === MaterialLearningGroupType.INTRODUCTION) {
      result = GenericsUtils.translateI18n("objects.type.intro");
    } else if (learningGroup === MaterialLearningGroupType.MOTIVATION) {
      result = GenericsUtils.translateI18n("objects.type.motivation");
    } else if (learningGroup === MaterialLearningGroupType.DEVELOPMENT) {
      result = GenericsUtils.translateI18n("objects.type.dev");
    } else if (learningGroup === MaterialLearningGroupType.CLOSURE) {
      result = GenericsUtils.translateI18n("objects.type.closure");
    }
    return result;
  }

  getIcon(type: string): string {
    let result = "";
    if (
      type?.includes("png") ||
      type?.includes("jpg") ||
      type?.includes("jpeg") ||
      type?.includes("svg")
    ) {
      result = "md-image-outlined";
    } else if (type?.includes("mp4") || type?.includes("x-mpegURL")) {
      result = "md-videolibrary-outlined";
    } else if (type?.includes("mp3")) {
      result = "md-audiofile-outlined";
    } else if (type?.includes("pdf")) {
      result = "md-pictureaspdf-outlined";
    } else {
      result = "md-filepresent-outlined";
    }
    return result;
  }
}
